import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as evaluationAPI from 'api/Dashboard';
import { TYPE_OF_FIELD_IN_COLUMN } from 'utils/scorecard';
const initalState = {
  data: null,
  callFlow: null,
  SamplinRate: null,
  aht: null,
  getPiechartData: null,
  tenureDistributionData: null,
  featureAnalysisData: null,
  keywordAnalaysisData: { data: null, slug: null, afterKey: null },
  topicAnalaysisData: { data: null, slug: null, afterKey: null },
  topKeywords: null,
  topTopics: null,
  Basicdata: null,
  Cqdata: null,
  CallsData: null,
  AgentqualityData: null,
  CampaignSummaryData: null,
  TopIssuesData: null,
  RepeatedDefaulterData: null,
  repeatedDefaulterFieldkey: null,
  TniViewData: null,
  // totalRecord: null,
  ui: {
    loading: false,
    msg: '',
    downloadreport: {
      loading: false,
      status: 'initalState'
    }
  },
  evaluationPaylod: {},
  trainingData: null,
  column: [],
  status: 'init',
  selected: {
    id: null,
    index: null
  },
  panelshow: true,
  agentScore: null,
  AgentQualitycolumn: [
    { title: 'Agent', key: 'agent', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
    { title: 'No of Calls', key: 'no_of_calls', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 190 },
    { title: 'AHT', key: 'aht', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 210 },
    { title: 'Quality Trend', key: 'quality_trend', type: TYPE_OF_FIELD_IN_COLUMN.PERCENTAGE, width: 210 }
  ]
};

const getDashbordDataState = (state) => state.dashbord;

const getDashbordData = createAsyncThunk('dashbord/getDashbordData', async (params) => {
  const res = await evaluationAPI.getDashbordConfigData(params);
  return res.data?.data;
});
const getGetCallFlow = createAsyncThunk('dashbord/getGetCallFlow', async (params) => {
  const res = await evaluationAPI.getCallFlow(params);
  return res.data?.data;
});
const getSamplinRate = createAsyncThunk('dashbord/getSamplinRate', async (params) => {
  const res = await evaluationAPI.getSamplinRate(params);
  return res.data?.data;
});
const getAht = createAsyncThunk('dashbord/getAht', async (params) => {
  const res = await evaluationAPI.getAht(params);
  return res.data?.data;
});

const getAgentScore = createAsyncThunk('dashbord/getAgentScore', async (params) => {
  const res = await evaluationAPI.getAgentScore(params);
  return res.data?.data;
});

const getBasicData = createAsyncThunk('dashbord/getBasicData', async (params) => {
  const res = await evaluationAPI.getBasicData(params);
  return res.data?.data;
});
const getCqdata = createAsyncThunk('dashbord/getCqdata', async (params) => {
  const res = await evaluationAPI.getCqdata(params);
  return res.data?.data;
});

const getCallsdata = createAsyncThunk('dashbord/getCallsdata', async (params) => {
  const res = await evaluationAPI.getCallsdata(params);
  return res.data?.data;
});
const getCallSentimentData = createAsyncThunk('dashbord/getCallSentimentData', async (params) => {
  const res = await evaluationAPI.getCallSentimentData(params);
  return res.data?.data;
});
const getPerformarsData = createAsyncThunk('dashbord/getPerformarsData', async (params) => {
  const res = await evaluationAPI.getPerformarsData(params);
  return res.data?.data;
});
const getTopicData = createAsyncThunk('dashbord/getTopicData', async (params) => {
  const res = await evaluationAPI.getTopicData(params);
  return res.data?.data;
});
const getParetoData = createAsyncThunk('dashbord/getParetoData', async (params) => {
  const res = await evaluationAPI.getParetoData(params);
  return res.data?.data;
});
const getKeywordsCloudData = createAsyncThunk('dashbord/getKeywordsCloudData', async (params) => {
  const res = await evaluationAPI.getKeywordsCloudData(params);
  return res.data?.data;
});
const getLobWiseCQData = createAsyncThunk('dashbord/getLobWiseCQData', async (params) => {
  const res = await evaluationAPI.getLobWiseCQData(params);
  return res.data?.data;
});
const getTeamWiseCQData = createAsyncThunk('dashbord/getTeamWiseCQData', async (params) => {
  const res = await evaluationAPI.getTeamWiseCQData(params);
  return res.data?.data;
});

const getTrainingRequirements = createAsyncThunk('dashbord/getTrainingRequirements', async (params) => {
  const res = await evaluationAPI.getTrainingRequirements(params);
  return res.data?.data;
});
const getPiechart = createAsyncThunk('dashbord/getPiechartData', async (params) => {
  const res = await evaluationAPI.getPiechartData(params);
  return res.data?.data;
});
const getTenureDistribution = createAsyncThunk('dashbord/getTenureDistribution', async (params) => {
  const res = await evaluationAPI.getTenureDistribution(params);
  return res.data?.data;
});
const getFeatureAnalysis = createAsyncThunk('dashbord/getFeatureAnalysis', async (params) => {
  const res = await evaluationAPI.getFeatureAnalysis(params);
  return res.data?.data;
});

const getKeywordAnalaysis = createAsyncThunk('dashbord/getKeywordAnalaysis', async (params) => {
  const res = await evaluationAPI.getKeywordAnalaysis(params);
  return res.data?.data;
});

const getTopKeywords = createAsyncThunk('dashbord/getTopKeywords', async (params) => {
  const res = await evaluationAPI.getTopKeywords(params);
  return res.data?.data;
});

const getTopicAnalaysis = createAsyncThunk('dashbord/getTopicAnalaysis', async (params) => {
  const res = await evaluationAPI.getTopicAnalaysis(params);
  return res.data?.data;
});

const getTopTopics = createAsyncThunk('dashbord/getTopTopics', async (params) => {
  const res = await evaluationAPI.getTopTopics(params);
  return res.data?.data;
});

const getAgentqualityPerformance = createAsyncThunk('dashbord/getAgentqualityPerformance', async (params) => {
  const res = await evaluationAPI.getAgentqualityPerformance(params);
  return res.data?.data;
});
const getCampaignSummary = createAsyncThunk('dashbord/getCampaignSummary', async (params) => {
  const res = await evaluationAPI.getCampaignSummary(params);
  return res.data?.data;
});
const getTopIssues = createAsyncThunk('dashbord/getTopIssues', async (params) => {
  const res = await evaluationAPI.getTopIssues(params);
  return res.data?.data;
});
const getRepeatedDefaulterView = createAsyncThunk('dashbord/getRepeatedDefaulterView', async (params) => {
  const res = await evaluationAPI.getRepeatedDefaulterView(params);
  return res.data?.data;
});
const getTniView = createAsyncThunk('dashbord/getTniView', async (params) => {
  const res = await evaluationAPI.getTniView(params);
  return res.data?.data;
});

const DashbordDataSlice = createSlice({
  name: 'dashbord',
  initialState: initalState,

  reducers: {
    resetState: () => {
      return initalState;
    },
    setPanelShow: (state, action) => {
      state.panelshow = action.payload;
    },
    resetkeywordAnalaysisData: (state) => {
      state.keywordAnalaysisData.data = null;
      state.keywordAnalaysisData.afterKey = null;
    },
    resetTopicAnalaysisData: (state) => {
      state.topicAnalaysisData.data = null;
      state.topicAnalaysisData.afterKey = null;
    },
    resetAgentQualityData: (state) => {
      state.AgentqualityData = null;
      state.fieldkey = null;
    },
    resetRepeatedDefaulterData: (state) => {
      state.RepeatedDefaulterData = null;
      state.repeatedDefaulterFieldkey = null;
    }
  },
  extraReducers: {
    [getDashbordData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getDashbordData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.data = action.payload;
    },

    [getDashbordData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getGetCallFlow.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getGetCallFlow.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.callFlow = action.payload;
    },

    [getGetCallFlow.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getSamplinRate.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getSamplinRate.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.SamplinRate = action.payload;
    },

    [getSamplinRate.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getAht.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getAht.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.aht = action.payload;
    },

    [getAht.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getAgentScore.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getAgentScore.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.agentScore = action.payload;
    },

    [getAgentScore.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getBasicData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getBasicData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.Basicdata = action.payload;
    },

    [getBasicData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getCqdata.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getCqdata.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.Cqdata = action.payload;
    },

    [getCqdata.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [getCallsdata.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getCallsdata.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.CallsData = action.payload;
    },
    [getCallsdata.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [getCallSentimentData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getCallSentimentData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.CallSentimentData = action.payload;
    },
    [getCallSentimentData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [getPerformarsData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getPerformarsData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.PerformarsData = action.payload;
    },
    [getPerformarsData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [getTopicData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getTopicData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.TopicData = action.payload;
    },
    [getTopicData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [getParetoData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getParetoData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.ParetoData = action.payload;
    },
    [getParetoData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [getKeywordsCloudData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getKeywordsCloudData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.KeywordsCloudData = action.payload;
    },
    [getKeywordsCloudData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [getLobWiseCQData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getLobWiseCQData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.lobWiseCqData = action.payload;
    },
    [getLobWiseCQData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [getTeamWiseCQData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getTeamWiseCQData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.teamWiseCqData = action.payload;
    },
    [getTeamWiseCQData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getTrainingRequirements.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getTrainingRequirements.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.trainingData = action.payload;
    },
    [getTrainingRequirements.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getPiechart.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getPiechart.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.getPiechartData = action.payload;
    },
    [getPiechart.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getTenureDistribution.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getTenureDistribution.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.tenureDistributionData = action.payload;
    },
    [getTenureDistribution.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getFeatureAnalysis.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getFeatureAnalysis.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.featureAnalysisData = action.payload;
    },
    [getFeatureAnalysis.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getKeywordAnalaysis.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getKeywordAnalaysis.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      const data = action.payload?.data;
      if (state.keywordAnalaysisData?.data && state.keywordAnalaysisData?.data?.length && data) {
        state.keywordAnalaysisData.data = [...state.keywordAnalaysisData.data, ...data];
      } else {
        state.keywordAnalaysisData.data = action.payload?.data;
      }
      state.keywordAnalaysisData.afterKey = action.payload.after_key;
      state.keywordAnalaysisData.slug = action.payload.slug;
    },
    [getKeywordAnalaysis.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getTopKeywords.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getTopKeywords.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.topKeywords = action.payload;
    },
    [getTopKeywords.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getTopicAnalaysis.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getTopicAnalaysis.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      const data = action.payload?.data;
      if (state.topicAnalaysisData?.data && state.topicAnalaysisData?.data?.length && data) {
        state.topicAnalaysisData.data = [...state.topicAnalaysisData.data, ...data];
      } else {
        state.topicAnalaysisData.data = action.payload?.data;
      }
      state.topicAnalaysisData.afterKey = action.payload.after_key;
      state.topicAnalaysisData.slug = action.payload.slug;
    },
    [getTopicAnalaysis.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getTopTopics.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getTopTopics.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.topTopics = action.payload;
    },
    [getTopTopics.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getAgentqualityPerformance.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getAgentqualityPerformance.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      const data = action.payload?.data;
      if (state.AgentqualityData && state.AgentqualityData?.length && data) {
        state.AgentqualityData = [...state.AgentqualityData, ...data];
      } else {
        state.AgentqualityData = action.payload.data;
      }
      state.fieldkey = action.payload.after_key;
      state.AgentQualitycolumn = action.payload.fields;
    },
    [getAgentqualityPerformance.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getCampaignSummary.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getCampaignSummary.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.CampaignSummaryData = action.payload;
    },
    [getCampaignSummary.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getTopIssues.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getTopIssues.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.TopIssuesData = action.payload;
    },
    [getTopIssues.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getRepeatedDefaulterView.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getRepeatedDefaulterView.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      const data = action.payload?.data;
      // Append when paging (scroll); replace on first page.
      if (state.RepeatedDefaulterData && state.RepeatedDefaulterData?.length && data) {
        state.RepeatedDefaulterData = [...state.RepeatedDefaulterData, ...data];
      } else {
        state.RepeatedDefaulterData = data;
      }
      state.repeatedDefaulterFieldkey = action.payload?.after_key;
    },
    [getRepeatedDefaulterView.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getTniView.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getTniView.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.TniViewData = action.payload;
    },
    [getTniView.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }
  }
});

const { resetState, setPanelShow, resetkeywordAnalaysisData, resetTopicAnalaysisData, resetAgentQualityData, resetRepeatedDefaulterData } =
  DashbordDataSlice.actions;

export default DashbordDataSlice.reducer;

export {
  getDashbordDataState,
  setPanelShow,
  resetkeywordAnalaysisData,
  resetTopicAnalaysisData,
  DashbordDataSlice,
  getCqdata,
  resetState,
  getBasicData,
  getSamplinRate,
  getDashbordData,
  getCallsdata,
  getCallSentimentData,
  getTopicData,
  getPerformarsData,
  getParetoData,
  getKeywordsCloudData,
  getLobWiseCQData,
  getTeamWiseCQData,
  getTrainingRequirements,
  getGetCallFlow,
  getAht,
  getAgentScore,
  getPiechart,
  getTenureDistribution,
  getFeatureAnalysis,
  getKeywordAnalaysis,
  getTopicAnalaysis,
  getAgentqualityPerformance,
  resetAgentQualityData,
  getTopKeywords,
  getTopTopics,
  getCampaignSummary,
  getTopIssues,
  getRepeatedDefaulterView,
  resetRepeatedDefaulterData,
  getTniView
};
